import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getSPDataWithParams, postSPDataWithoutParams } from 'src/supportPortal/services/services'

const BASE = '/api/secure/clinic-success-admin/patient-diagnostics'

// Only Clinic Success Admins (and full Admins) may run patient diagnostics — mirrors the backend
// ClinicSuccessAdminBaseController gate (ROLE_CLINIC_SUCCESS_ADMIN / ROLE_ADMIN).
export function canRunPatientDiagnostics() {
  const roles = getAllRolesInBoolean() || {}
  return Boolean(roles.isClinicSuccessAdmin || roles.isAdmin)
}

function unwrap(response, key, fallbackMessage) {
  const payload = response?.data?.data?.[key]
  if (payload === undefined || payload === null) {
    const message = response?.data?.message || response?.message || fallbackMessage
    throw new Error(message)
  }
  return payload
}

// Returns a PrescriptionAgePreviewDto: patient DOB + one row per prescription.
export async function getPrescriptionAgeDiagnostics(patientNumber) {
  const response = await getSPDataWithParams(`${BASE}/prescription-ages`, { patientNumber })
  return unwrap(response, 'prescriptionAgeDiagnostics', 'Failed to load prescription age diagnostics')
}

// body: { patientNumber, dryRun, entries: [{ prescriptionId, ageAsOnEpochMillis }] }
// Returns a PrescriptionAgeApplyResultDto (per-row old/new + counts). dryRun=true previews only.
export async function applyPrescriptionAgeDiagnostics(body) {
  const response = await postSPDataWithoutParams(`${BASE}/prescription-ages/apply`, body)
  return unwrap(response, 'prescriptionAgeDiagnosticsResult', 'Failed to apply prescription age update')
}
